import { Section, SHELL } from '@/components/base/Frame';
import InstrumentedOutcomesV3 from './InstrumentedOutcomesV3';

/* V3 owns its own header, 2×2 grid and dividers. Outer Screen Frame unchanged. */
export default function Outcomes() {
  return (
    <Section id="outcomes" divider growOnShort className="relative overflow-hidden isolate">
      <div className={`${SHELL} relative flex min-h-0 flex-1 flex-col overflow-hidden`}>
        <InstrumentedOutcomesV3 className="min-h-0 flex-1" />
      </div>
    </Section>
  );
}